import { useState, useEffect } from 'react';

/**
 * Hook to watch for website language changes (Google Translate-aware).
 */
export const useLanguage = () => {
  const [lang, setLang] = useState('fr');

  useEffect(() => {
    // Check initial lang from html tag
    const getHtmlLang = () => {
      const htmlLang = document.documentElement.lang || 'fr';
      return htmlLang.split('-')[0]; // convert 'en-US' to 'en'
    };

    setLang(getHtmlLang());

    // Observe changes to html lang attribute (Google Translate does this)
    const observer = new MutationObserver(() => {
      setLang(getHtmlLang());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang']
    });

    return () => observer.disconnect();
  }, []);

  return lang;
};
